// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse {
    'success': boolean;
    'messages': Array<string>;
    'data': string | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse>> = [
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
        {
            "name":     "data",
            "baseName": "data",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return DebitCardDebitCardGetLashPatientDebitCardLast4DefaultResponse.attributeTypeMap;
    }
}
